export class DeleteFileINModel {
    filePath: string;
}
